import { t } from '../../localization';
import { PER_MONTH, PER_YEAR } from '../../common/constants/periods';

const getToggleData = (period, onChange, disabled) => ({
  items: [
    {
      id: PER_YEAR,
      label: t('Annual'),
      onClick: onChange,
      onKeyDown: onChange,
    },
    {
      id: PER_MONTH,
      label: t('Monthly'),
      onClick: onChange,
      onKeyDown: onChange,
    },
  ],
  disabled,
  selectedId: period,
});

export default getToggleData;
